(function () {
  'use strict';

  var OWNER = 'cart-drawer';

  function lockScroll() {
    if (window.CdiScrollLock) {
      window.CdiScrollLock.lock(OWNER);
    } else {
      document.documentElement.style.overflowY = 'hidden';
    }
  }

  function unlockScroll() {
    if (window.CdiScrollLock) {
      window.CdiScrollLock.unlock(OWNER);
    } else {
      document.documentElement.style.overflowY = '';
    }
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var wasOpen = drawer.classList.contains('active');

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        var isOpen = drawer.classList.contains('active');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (isOpen) lockScroll();
        else unlockScroll();
      });
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
